module.exports = __webpack_public_path__ + "img/ticket_star.963163f3.svg";